import CloningEnvironments from "../../../../src/courses/partials/responsible-development/cloning-environments.mdx";
import * as React from 'react';
export default {
  CloningEnvironments,
  React
};